import { useMutation } from '@apollo/client';

import { UpdateMilestoneInput } from '../../apollo/__generated__/graphql';
import { EVENTS } from '../../event/graphql/query/eventsQuery.graphql';
import { MILESTONES } from '../../event/graphql/query/milestonesQuery.graphql';
import { UPDATE_MILESTONE } from '../graphql/mutation/updateMilestoneMutation.graphql';

export const useUpdateMilestoneMutation = (onCompleted: () => void) => {
  const [mutate] = useMutation(UPDATE_MILESTONE, { onCompleted });

  const updateMilestone = (updateMilestoneInput: UpdateMilestoneInput) => {
    mutate({
      variables: {
        updateMilestoneInput,
      },
      refetchQueries: [MILESTONES, EVENTS],
    });
  };

  return { updateMilestone };
};
